$(document).ready(function () {
  $(".customize-now").click(function () {
    $(".add-action-errors .errors").hide();
    $(".modal-charm-buider").fadeIn();
  });

  $(".close-charm-buider").click(function () {
    $(".modal-charm-buider").fadeOut();
  });
  $(".select-size-input").change(function () {
    $(".error-msg").remove();
  });
  $(".chain-item").click(function () {
    $(".error-msg").remove();
    $(".chain-item").removeClass("selected");
    $(this).addClass("selected");

    $(".image-charm-buider-wrapper .image-wrapper .main-image img").attr('src',`${$(this).find("img").attr("src")}`);
    $(".image-charm-buider-wrapper .image-wrapper .main-image").addClass(
      "active"
    );
    $(".charm-list-item").css("pointer-events", "auto");
    $("#product-form-custom-necklace")
      .find('input[name="id"]')
      .val($(this).data("varid"));
  });
  $(".charm-title").click(function () {
    $(".charm-title").removeClass("active");
    $(".charm-list-items-wrapper").hide();
    $(
      '.charm-list-items-wrapper[data-index="' + $(this).data("index") + '"]'
    ).show();
    $(this).addClass("active");
  });

  // <div
  //                       class="charm-item"
  //                       data-ptitle="${$(this)
  //                         .find(".charm-item-title")
  //                         .html()}"
  //                       data-ccount="${val}"
  //                       data-vid="${$(this).data("itemid")}"
  //                       data-crotate="0"
  //                     >
  //                       <img class="charm-image" src="${$(this)
  //                         .find("img")
  //                         .attr("src")}">
  //                       <div class="charm-rotate_l 1">
  //                         <img src="https://cdn.shopify.com/s/files/1/0474/8519/0300/files/rotate_l.png?v=1734348540">
  //                       </div>
  //                       <div class="charm-close 1">
  //                         <div class="remove-charm">X</div>
  //                       </div>
  //                       <div class="charm-rotate_r 1">
  //                         <img src="https://cdn.shopify.com/s/files/1/0474/8519/0300/files/rotate_l.png?v=1734348540">
  //                       </div>
  //                     </div>

  $(".charm-list-item").click(function (e) {
    $(".error-msg").remove();
    if ($(".chain-item.selected").length > 0) {
      $(this).addClass("selected");
      var val = Number($(this).find("input").val()) + 1;
      $(this).find("input").val(val);
      $(".image-charm-buider-wrapper .image-wrapper").append(`
                      <div class="charm-item"
                          data-ptitle="${$(this).find(".charm-item-title").html()}"
                          data-ccount="${val}"
                          data-vid="${$(this).data("itemid")}"
                          data-crotate="0"
                      >
                          <img class="charm-image" alt="${$(this).find(".charm-item-title").html()} image" src="${$(this).find("img").attr("src")}">
                          <div class="tw:flex tw:-mt-4 tw:justify-between tw:items-center tw:gap-2">
                              <button class="charm-rotate_l 1 tw:p-2 tw:size-6">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate-ccw-icon lucide-rotate-ccw"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
                              </button>
                              <button class="charm-close remove-charm tw:p-2 tw:size-6" aria-label="remove">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-x-icon lucide-circle-x"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>
                              </button>
                              <button class="charm-rotate_r 1 tw:p-2 tw:size-6">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate-cw-icon lucide-rotate-cw"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
                              </button>
                          </div>
                      </div>
                      `);
      initEvents();
    } else {
      $(".select-chain-wrapper .select-title").after(
        '<div class="error-msg">Select chain first to add charms.</div>'
      );
      alert("Select chain first to add charms.");
    }
  });
  $(".charms-input-wrapper .minus").click(function () {
    var $input = $(this).parent().find("input");
    var val = $input.val();
    var count = parseInt($input.val()) - 1;
    count = count < 0 ? 0 : count;
    $input.val(count);
    $input.change();
    var ptitle = $(this)
      .parents(".charm-list-item")
      .find(".charm-item-title")
      .html();
    $(
      '.charm-item[data-ptitle="' + ptitle + '"][data-ccount="' + val + '"]'
    ).remove();
    if (count == 0) {
      $(this).parents(".charm-list-item").removeClass("selected");
    }
    return false;
  });

  // <div
  //                 class="charm-item"
  //                 data-ptitle="${$(this)
  //                   .parents(".charm-list-item")
  //                   .find(".charm-item-title")
  //                   .html()}"
  //                 data-ccount="${val}"
  //                 data-vid="${$(this)
  //                   .parents(".charm-list-item")
  //                   .data("itemid")}"
  //                 data-crotate="0"
  //               >
  //                 <img class="charm-image" src="${$(this)
  //                   .parents(".charm-list-item")
  //                   .find("img")
  //                   .attr("src")}">
  //                 <div class="charm-rotate_l 1">
  //                   <img src="https://cdn.shopify.com/s/files/1/0474/8519/0300/files/rotate_l.png?v=12722470450602692451">
  //                 </div>
  //                 <div class="charm-close 1">
  //                   <div class="remove-charm">X</div>
  //                 </div>
  //                 <div class="charm-rotate_r 1">
  //                   <img src="https://cdn.shopify.com/s/files/1/0474/8519/0300/files/rotate_l.png?v=12722470450602692451">
  //                 </div>
  //               </div>

  $(".charms-input-wrapper .plus").click(function () {
    $(".error-msg").remove();
    if ($(".chain-item.selected").length > 0) {
      var $input = $(this).parent().find("input");
      var val = parseInt($input.val()) + 1;
      $input.val(val);
      $input.change();
      $(this).parents(".charm-list-item").addClass("selected");
      $(".image-charm-buider-wrapper .image-wrapper").append(`
                      <div class="charm-item"
                          data-ptitle="${$(this).parents(".charm-list-item").find(".charm-item-title").html()}"
                          data-ccount="${val}"
                          data-vid="${$(this).parents(".charm-list-item").data("itemid")}"
                          data-crotate="0"
                      >
                          <img class="charm-image" alt="${$(this).parents(".charm-list-item").find(".charm-item-title").html()} image" src="${$(this).parents(".charm-list-item").find("img").attr("src")}">
                          <div class="tw:flex tw:-mt-4 tw:justify-between tw:items-center tw:gap-2">
                              <button class="charm-rotate_l 1 tw:p-2 tw:size-6">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate-ccw-icon lucide-rotate-ccw"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
                              </button>
                              <button class="charm-close remove-charm tw:p-2 tw:size-6" aria-label="remove">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-x-icon lucide-circle-x"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>
                              </button>
                              <button class="charm-rotate_r 1 tw:p-2 tw:size-6">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate-cw-icon lucide-rotate-cw"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
                              </button>
                          </div>
                      </div>
                `);
      initEvents();
    } else {
      $(".select-chain-wrapper .select-title").after(
        '<div class="error-msg">Select chain first to add charms.</div>'
      );
      alert("Select chain first to add charms.");
    }
    return false;
  });

  function initEvents() {
    $(".charm-item").removeClass("alerts-border");
    $(".charm-item").draggable({
      containment: ".image-wrapper",
      scroll: false,
    });
    $(".charm-item").on("dragstart", function (event, ui) {
      $(".charm-item").removeClass("alerts-border");
      $(this).addClass("dragged");
    });
    $(".charm-rotate_r").click(function () {
      $(".charm-item").removeClass("alerts-border");
      var crotate = $(this).closest(".charm-item").data("crotate");
      crotate = crotate + 10;
      $(this)
        .closest(".charm-item")
        .css("transform", "rotate(" + crotate + "deg)");
      $(this).closest(".charm-item").data("crotate", crotate);
    });
    $(".charm-rotate_l").click(function () {
      $(".charm-item").removeClass("alerts-border");
      var crotate = $(this).closest(".charm-item").data("crotate");
      crotate = crotate - 10;
      $(this)
        .closest(".charm-item")
        .css("transform", "rotate(" + crotate + "deg)");
      $(this).closest(".charm-item").data("crotate", crotate);
    });
    $(".remove-charm")
      .unbind()
      .click(function () {
        $(".charm-item").removeClass("alerts-border");
        var val =
          $(
            '.charm-list-item[data-itemid="' +
              $(this).parents(".charm-item").data("vid") +
              '"]'
          )
            .find("input")
            .val() - 1;
        $(
          '.charm-list-item[data-itemid="' +
            $(this).parents(".charm-item").data("vid") +
            '"]'
        )
          .find("input")
          .val(val);
        if (val <= 0) {
          $(
            '.charm-list-item[data-itemid="' +
              $(this).parents(".charm-item").data("vid") +
              '"]'
          ).removeClass("selected");
        }
        console.log(val);
        $(this).parents(".charm-item").remove();
      });
    $(".charm-item").on("mousedown touchstart", function () {
      $(".charm-item").removeClass("alerts-border");
      $(".charm-rotate_l").css("visibility", "hidden");
      $(".charm-rotate_l").css("opacity", 0);
      $(".charm-rotate_r").css("visibility", "hidden");
      $(".charm-rotate_r").css("opacity", 0);
      $(".charm-close").css("visibility", "hidden");
      $(".charm-close").css("opacity", 0);
      $(this).find(".charm-rotate_l").css("visibility", "visible");
      $(this).find(".charm-rotate_l").css("opacity", 1);
      $(this).find(".charm-rotate_r").css("visibility", "visible");
      $(this).find(".charm-rotate_r").css("opacity", 1);
      $(this).find(".charm-close").css("visibility", "visible");
      $(this).find(".charm-close").css("opacity", 1);
    });
    $(".charm-item").on("mousemove touchmove", function () {
      $(".charm-item").removeClass("alerts-border");
      $(".charm-rotate_l").css("visibility", "hidden");
      $(".charm-rotate_l").css("opacity", 0);
      $(".charm-rotate_r").css("visibility", "hidden");
      $(".charm-rotate_r").css("opacity", 0);
      $(".charm-close").css("visibility", "hidden");
      $(".charm-close").css("opacity", 0);
      $(this).find(".charm-rotate_l").css("visibility", "visible");
      $(this).find(".charm-rotate_l").css("opacity", 1);
      $(this).find(".charm-rotate_r").css("visibility", "visible");
      $(this).find(".charm-rotate_r").css("opacity", 1);
      $(this).find(".charm-close").css("visibility", "visible");
      $(this).find(".charm-close").css("opacity", 1);
    });
    $(".charm-item").on("mouseup touchend touchcancel mouseleave", function () {
      $(".charm-item").removeClass("alerts-border");
      var this2 = this;

      if ($(this).hasClass("removestar") == false) {
        setTimeout(function () {
          $(this2).find(".charm-rotate_l").css("visibility", "hidden");
          $(this2).find(".charm-rotate_l").css("opacity", 0);
          $(this2).find(".charm-rotate_r").css("visibility", "hidden");
          $(this2).find(".charm-rotate_r").css("opacity", 0);
          $(this2).find(".charm-close").css("visibility", "hidden");
          $(this2).find(".charm-close").css("opacity", 0);
          $(this).removeClass("removestar");
        }, 5000);
      }
      $(this).addClass("removestar");
    });
  }

  $(".submit-selected-items").click(function () {
    $(".charm-item").removeClass("alerts-border");
    $(".error-msg").remove();
    $(".charm-rotate_l").css("visibility", "hidden");
    $(".charm-rotate_l").css("opacity", 0);
    $(".charm-rotate_r").css("visibility", "hidden");
    $(".charm-rotate_r").css("opacity", 0);
    $(".charm-close").css("visibility", "hidden");
    $(".charm-close").css("opacity", 0);
    var proceed = true;
    if ($(".chain-item.selected").length == 0) {
      if ($(".select-size-wrapper").length > 0) {
        $(".select-chain-wrapper .select-title").after(
          '<div class="error-msg">Select bracelet first to add charms.</div>'
        );
        alert("Select Bracelet first.");
      } else {
        $(".select-chain-wrapper .select-title").after(
          '<div class="error-msg">Select chain first to add charms.</div>'
        );
        alert("Select chain first.");
      }
      proceed = false;
    }
    if ($(".select-size-wrapper").length > 0 && proceed == true) {
      if ($(".select-size-input:checked").length == 0) {
        $(".select-size-wrapper .select-title").after(
          '<div class="error-msg">Select a size first to add charms.</div>'
        );
        alert("Select Size ");
        proceed = false;
      }
    }
    if ($(".charm-list-item.selected").length == 0 && proceed == true) {
      $(".select-charm-wrapper .select-title").after(
        '<div class="error-msg">Select at least one charm</div>'
      );
      alert("Select at least one charm");
      proceed = false;
    }
    var setposition = true;
    $(".charm-item").each(function () {
      if ($(this).hasClass("dragged") == false) {
        $(this).addClass("alerts-border");
        setposition = false;
      }
    });
    if (setposition == false) {
      alert("Please move your charms in to position");
      proceed = false;
    }

    var totalprice = Number($(".chain-item.selected").data("price"));
    if (proceed == true) {
      $(".loading-spinner-overlay").show();
      var selcharms = "";
      $(".charm-list-item.selected").each(function () {
        totalprice = totalprice + Number($(this).data("price"));
        selcharms =
          selcharms +
          `<div class="selected-charm-item" data-itemid="${$(this).data(
            "itemid"
          )}"
          data-qty="${$(this)
            .find(".charms-input-wrapper")
            .find("input")
            .val()}"
          >
           <div class="remove-selected-charm">x</div>
           <img src="${$(this).find("img").attr("src")}">
           <div class="selected-item-title">${$(this)
             .find(".charm-item-title")
             .html()} x ${$(this)
            .find(".charms-input-wrapper")
            .find("input")
            .val()}</div>
        </div>`;
      });
      $(".selected-charms-list").html(selcharms);
      $(".selected-charms").show();
      $(".product__add-to-cart-button")
        .find("span[data-button-price]")
        .html(themeVendor.themeCurrency.formatMoney(totalprice));

      $(".remove-selected-charm").click(function () {
        console.log(
          $(this).parents(".selected-charm-item").data("itemid") + " gggg"
        );
        var elem = $(
          '.charm-list-item[id="' +
            $(this).parents(".selected-charm-item").data("itemid") +
            '"]'
        );
        elem.find("input").val(0);
        elem.removeClass("selected");
        $(
          '.charm-item[data-pid="' +
            $(this).parents(".selected-charm-item").data("itemid") +
            '"]'
        ).remove();

        setTimeout(async () => {
            await setPreviewImage();
        }, 500);
      });
      setTimeout(async () => {
          await setPreviewImage();
      }, 500);
    }
  });
  $(".reset-customization").click(function () {
    window.location.reload();
  });


  // iOS-safe image loader for canvas
  const imageCache = {};

  function loadImage(src) {
    if (!src) {
      return Promise.reject("Invalid image src");
    }

    // cache to avoid reloading same image
    if (imageCache[src]) {
      return Promise.resolve(imageCache[src]);
    }

    return new Promise((resolve, reject) => {
      const img = new Image();

      // REQUIRED for Shopify CDN + canvas export
      img.crossOrigin = "anonymous";

      img.onload = () => {
        imageCache[src] = img;
        resolve(img);
      };

      img.onerror = (e) => {
        console.error("Image failed to load:", src);
        reject(e);
      };

      img.src = src;
    });
  }

  function getRotationFromStyle(el) {
    const transform = el.style.transform || "";
    const match = transform.match(/rotate\(([-\d.]+)deg\)/);
    return match ? parseFloat(match[1]) : 0;
  }

  async function setPreviewImage() {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = 600;
    canvas.height = 600;

    const container = document.getElementById("custom-necklace-main-image");

    // Scale factor (important for responsive layouts)
    const scaleX = canvas.width / container.offsetWidth;
    const scaleY = canvas.height / container.offsetHeight;

    // Base image
    const baseImg = await loadImage(
      document.querySelector(".chain-item.selected img").src
    );
    ctx.drawImage(baseImg, 0, 0, canvas.width, canvas.height);


    // Draw charms
    const charmEls = document.querySelectorAll(".charm-item.ui-draggable");

    for (const el of charmEls) {
      const imgEl = el.querySelector("img");
      if (!imgEl) continue;

      const img = await loadImage(imgEl.src);

      // 🔥 Read position
      const x = (parseFloat(el.style.left) || 0) * scaleX;
      const y = (parseFloat(el.style.top) || 0) * scaleY;
      const w = el.offsetWidth * scaleX;
      const h = el.offsetHeight * scaleY;

      // 🔥 Read rotation
      const rotation = getRotationFromStyle(el);

      ctx.save();
      ctx.translate(x + w / 2, y + h / 2);
      ctx.rotate((rotation * Math.PI) / 180);
      ctx.drawImage(img, -w / 2, -h / 2, w, h);
      ctx.restore();
    }

    canvas.toBlob(blob => {
      if (!blob) return;

      const file = new File([blob], "preview.jpg", {
        type: "image/jpeg"
      });

      const dt = new DataTransfer();
      dt.items.add(file);
      document.querySelector(
        'input[type="file"][name="properties[Preview Image]"]'
      ).files = dt.files;

      $(".output_image_custom img").attr("src", URL.createObjectURL(blob));
      $(".modal-charm-buider").fadeOut();
      $(".product__slides").hide();
      $(".media__thumb__wrapper").hide();
      $(".output_image_custom").show();
      const startEvent = new Event("theme:reinitslider");
      document.dispatchEvent(startEvent);
      $(".product__grid--slides").hide()
      $(".loading-spinner-overlay").hide();
      $(".customize-now").html("Edit Customization");
      $(".reset-customization").show();
    }, "image/jpeg", 0.85);
  }




  // async function setPreviewImage() {
  //   const node = document.getElementById("custom-necklace-main-image");
  //   if (!node) return;

  //   // 1. Fix Lazy Loading (Crucial for iOS)
  //   node.querySelectorAll('img').forEach(img => img.loading = 'eager');

  //   const options = {
  //     scale: 1,                
  //     useCORS: true,
  //     allowTaint: true,
  //     backgroundColor: "#fff",
  //     logging: false,
  //     removeContainer: true,
  //     width: 600,              
  //     height: 600,
  //     windowWidth: 600,
  //     windowHeight: 600,
  //     allowTaint: false,
  //     logging: false
  //   };

  //   await html2canvas(node, options); 

  //   // 3. Actual capture
  //   const canvas = await html2canvas(node, options);

  //   canvas.toBlob(
  //     blob => {
  //       if (!blob || blob.size === 0) return;

  //       const file = new File([blob], "preview.jpg", {
  //         type: "image/jpeg"
  //       });

  //       const dt = new DataTransfer();
  //       dt.items.add(file);
  //       document.querySelector(
  //         'input[type="file"][name="properties[Preview Image]"]'
  //       ).files = dt.files;

  //       $(".output_image_custom img").attr("src", URL.createObjectURL(blob));
  //       console.error("blob here>>>", blob);
  //       $(".modal-charm-buider").fadeOut();
  //       $(".product__slides").hide();
  //       $(".media__thumb__wrapper").hide();
  //       $(".output_image_custom").show();
  //       const startEvent = new Event("theme:reinitslider");
  //       document.dispatchEvent(startEvent);
  //       $(".product__grid--slides").hide()
  //       $(".loading-spinner-overlay").hide();
  //       $(".customize-now").html("Edit Customization");
  //       $(".reset-customization").show();
  //     },
  //     "image/jpeg",
  //     0.8 // 🔥 JPEG ONLY
  //   );
    
  // }


    // async function setPreviewImage() {
  //   var node = document.getElementById("custom-necklace-main-image");

  //   html2canvas(node).then((canvas) => {
  //     canvas.toBlob(function (blob) {
  //       var file = new File([blob], "my_image_new.png", {
  //         type: "image/png",
  //         lastModified: new Date().getTime(),
  //       });
  //       const fileInput = document.querySelector(
  //         'input[type="file"][name="properties[Preview Image]"]'
  //       );
  //       const dataTransfer = new DataTransfer();
  //       dataTransfer.items.add(file);
  //       fileInput.files = dataTransfer.files;

  //       let url = URL.createObjectURL(blob);
  //       console.error("blob url>>>",url);
  //       $(".output_image_custom").find("img").attr("src", url);
  //       $(".modal-charm-buider").fadeOut();
  //       $(".product__slides").hide();
  //       $(".media__thumb__wrapper").hide();
  //       $(".output_image_custom").show();
  //       const startEvent = new Event("theme:reinitslider");
  //       document.dispatchEvent(startEvent);
  //       $(".loading-spinner-overlay").hide();
  //       $(".customize-now").html("Edit Customization");
  //       $(".reset-customization").show();
  //     });
  //   });
  // }


  $(".charm-selection-btn").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const index = this.dataset.index;

    $(".charm-selection-btn").removeClass("active");
    $(this).addClass("active");

    $(".charm-list-items-wrapper")
      .hide();

    $(`.charm-list-items-wrapper[data-index='${index}']`)
      .show();
  });


  $(".product__add-to-cart-button").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    var this2 = this;
    $(".add-action-errors").hide();
    $(".add-action-errors").html("");
    if ($(".selected-charm-item").length <= 0) {
      $(".add-action-errors").html(
        `<div class="errors">Please build you custom necklace first.</div>`
      );
      $(".add-action-errors").show();
      return;
    }
    $(this).addClass("loading");
    var random = Math.floor(Math.random() * 1000000000);
    $("#product-form-custom-necklace")
      .find('input[name="properties[_bundleId]"]')
      .val(random);
    var items = [];
    $(".selected-charm-item").each(function () {
      var obj = {};
      obj["id"] = $(this).data("itemid");
      obj["quantity"] = $(this).data("qty");
      var prop = {};
      prop["_isBundleCharm"] = true;
      prop["_bundleId"] = $('input[name="properties[_bundleId]"]').val();
      obj["properties"] = prop;
      items.push(obj);
    });
    let formData = {
      items: items,
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((r) => {
        if (r.status == 422) {
          $(".add-action-errors").html("");
          $(".add-action-errors").html(`${r.message}`);
          $(".add-action-errors").show();
          return;
        }
        addchain();
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    function addchain() {
      var form = document.querySelector("#product-form-custom-necklace");
      var random = Math.floor(Math.random() * 1000000000);

      var n = new FormData(form);
      if ($(".select-size-input:checked").length > 0) {
        n.append(
          "properties[Bracelet Size]",
          $(".select-size-input:checked").val()
        );
      }
      fetch("/cart/add.js", {
        method: "POST",
        body: n,
        credentials: "same-origin",
      })
        .then((e) => e.json())
        .then(
          function (t) {
            if (422 === t.status) {
              $(".add-action-errors").html("");
              $(".add-action-errors").html(`${t.message}`);
              $(".add-action-errors").show();
            } else {
              $(this2).removeClass("loading");
              $(this2).addClass("has-success");
              var event = new CustomEvent("theme:drawer:initialize:open");
              document.dispatchEvent(event);
              var drawer = document.querySelector(
                '[data-drawer="drawer-cart"]'
              );
              
              drawer.dispatchEvent(new CustomEvent("theme:drawer:open"));
              
              setTimeout(function () {
                $(this2).removeClass("has-success");
              }, 2000);
            }
          }.bind(this)
        );
        fetch("/cart.js").then((res)=>res.json()).then((data)=>document.dispatchEvent(new CustomEvent("theme:cart:change",{detail:{cart:data},bubbles:!0})));
    
    }
  });
});
window.addEventListener("pageshow", () => {
  if ($(".selected-charm-item").length > 0) {
    window.location.reload();
  }
});
